import type {Sentence} from 'types';
import {AI_TONES} from 'utils/aiScore';

/**
 * Share of the text each tone covers, weighted by characters, as fractions that
 * sum to exactly 1 (largest remainder method). One rule for every surface that
 * shows a "Text composition" breakdown — the scan results panel and the
 * Humanizer's tag popovers must not round the same segments differently.
 */
export const calculateTonesComposition = (segments: Sentence[]): Record<string, number> => {
    const toneChars: Record<string, number> = {...Object.fromEntries(AI_TONES.map(tone => [tone, 0])), "": 0};
    let total = 0;
    segments.forEach(item => {
        toneChars[item.tone || ""] += item.text?.length || 0;
        total += item.text?.length || 0;
    });

    if (total === 0) return toneChars;

    const entries = AI_TONES.map(k => {
        const raw = (toneChars[k] / total) * 100;
        return {k, floored: Math.floor(raw), remainder: raw % 1};
    });
    let remaining = 100 - entries.reduce((s, e) => s + e.floored, 0);
    entries.sort((a, b) => b.remainder - a.remainder);
    for (const e of entries) {
        if (remaining <= 0) break;
        e.floored++;
        remaining--;
    }
    for (const e of entries) toneChars[e.k] = e.floored / 100;

    return toneChars;
};
